import {
  Flex,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Select,
  Text,
} from '@chakra-ui/react'
import { Filter } from 'react-feather'
import { SelectOptionProps } from '../../elements/formElements/formElements'

type PortfolioFilterProps = {
  onBuildingFilterChange: (props: {
    filterField:
      | 'isOccupied'
      | 'isSubscribedOptitwin'
      | 'isSubscribedDatalake'
      | 'company'
    value: string | boolean
  }) => void
  companySelectOptions?: SelectOptionProps[]
}

const PortfolioFilter = (props: PortfolioFilterProps) => {
  const { onBuildingFilterChange, companySelectOptions } = props

  return (
    <Popover placement="left" closeOnBlur={false}>
      <PopoverTrigger>
        <IconButton
          aria-label="Search database"
          icon={<Filter />}
          colorScheme={'purple'}
          variant={'ghost'}
        />
      </PopoverTrigger>
      <PopoverContent bg="white">
        <PopoverHeader pt={4} fontWeight="bold" border="0">
          Filter the buildings
        </PopoverHeader>
        <PopoverArrow bg="white" />
        <PopoverCloseButton />
        <PopoverBody>
          <Flex mb={3} flexDir={'column'}>
            <Text
              textTransform={'uppercase'}
              color={'grey'}
              fontSize={'12px'}
              mb={1}
            >
              Building Occupied
            </Text>
            <Select
              defaultValue={'any'}
              onChange={(e) =>
                onBuildingFilterChange({
                  filterField: 'isOccupied',
                  value:
                    e.target.value === 'yes'
                      ? true
                      : e.target.value === 'no'
                        ? false
                        : 'any',
                })
              }
            >
              <option value="any">Any</option>
              <option value={'yes'}>Occupied</option>
              <option value={'no'}>Vacant</option>
            </Select>
          </Flex>

          <Flex mb={3} flexDir={'column'}>
            <Text
              textTransform={'uppercase'}
              color={'grey'}
              fontSize={'12px'}
              mb={1}
            >
              Subscribed to Opti-twin
            </Text>
            <Select
              defaultValue={'any'}
              onChange={(e) =>
                onBuildingFilterChange({
                  filterField: 'isSubscribedOptitwin',
                  value:
                    e.target.value === 'yes'
                      ? true
                      : e.target.value === 'no'
                        ? false
                        : 'any',
                })
              }
            >
              <option value="any">Any</option>
              <option value={'yes'}>Yes</option>
              <option value={'no'}>No</option>
            </Select>
          </Flex>

          <Flex mb={3} flexDir={'column'}>
            <Text
              textTransform={'uppercase'}
              color={'grey'}
              fontSize={'12px'}
              mb={1}
            >
              Subscribed to Data lake
            </Text>
            <Select
              defaultValue={'any'}
              onChange={(e) =>
                onBuildingFilterChange({
                  filterField: 'isSubscribedDatalake',
                  value:
                    e.target.value === 'yes'
                      ? true
                      : e.target.value === 'no'
                        ? false
                        : 'any',
                })
              }
            >
              <option value="any">Any</option>
              <option value={'yes'}>Yes</option>
              <option value={'no'}>No</option>
            </Select>
          </Flex>

          <Flex mb={3} flexDir={'column'}>
            <Text
              textTransform={'uppercase'}
              color={'grey'}
              fontSize={'12px'}
              mb={1}
            >
              Companies
            </Text>
            <Select
              defaultValue={'any'}
              onChange={(e) =>
                onBuildingFilterChange({
                  filterField: 'company',
                  value: e.target.value,
                })
              }
            >
              <option value="any">Any</option>
              {companySelectOptions?.map((options) => (
                <option value={options.value}>{options.text}</option>
              ))}
            </Select>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}

export default PortfolioFilter
